<div class="ion-padding full-height full-width flex-vertical-center ion-text-center loading-screen--wrapper">
    <lib-loading-spinner size="70px" />
    <div *ngIf="title || text" class="loading-screen--content">
        <h1 *ngIf="title" class="text-title">{{ title }}</h1>
        <p *ngIf="text">{{ text }}</p>
    </div>
</div>
